<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="warehouseArea.pkId ? '编辑' : '新建'"
      width="600px"
      top="10vh"
      @close="$reset('form')">
    <el-form ref="form" :rules="ruleValidate" :model="warehouseArea" label-width="80px">
      <el-form-item label="库区编号">
        <el-input v-model="warehouseArea.warehouseAreaNo" :disabled="warehouseArea.pkId>0"/>
      </el-form-item>
      <el-form-item label="库区名称" prop="warehouseAreaName">
        <el-input v-model="warehouseArea.warehouseAreaName" placeholder="请输入库区名称"/>
      </el-form-item>
      <el-form-item label="所属仓库" prop="warehouseName">
        <el-input v-model="warehouseArea.warehouseName" placeholder="请选择所属仓库" readonly>
          <el-button slot="append" icon="el-icon-search" @click="$refs.selectWarehouse.open()"/>
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
      <warehouse-select ref="selectWarehouse" @select="selectWarehouse"/>
    </span>
  </el-dialog>
</template>

<script>
  import WarehouseSelect from "@/views/information/WarehouseNew/WarehouseSelect";

  export default {
    components: {
      WarehouseSelect,
    },
    data() {
      return {
        dialogVisible: false,
        warehouseArea: {
          pkId: 0,
          warehouseAreaNo: "",
          warehouseAreaName: "",
          warehouseId: 0,
          warehouseName: "",
          warehouseNo: "",
        },
        ruleValidate: {
          warehouseAreaName: [{ required: true, message: "请输入名称", trigger: "blur" }],
          warehouseName: [{ required: true, message: "请选择仓库", trigger: "blur" }],
        },
        submitLoading: false,
      };
    },

    methods: {
      open(mark, row) {
        this.dialogVisible = true;
        if (row) {
          this.warehouseArea = Object.assign(this.warehouseArea, row);
          this.warehouseArea.warehouseNo = row.warehouseNo;
          this.warehouseArea.warehouseName = row.warehouseName;
          this.warehouseArea.warehouseAreaNo = row.warehouseAreaNo;
          this.warehouseArea.warehouseAreaName = row.warehouseAreaName;
          this.warehouseArea.warehouseId = row.warehouseId;
          this.warehouseArea.pkId = row.pkId;
        }
      },
      // 仓库选择
      selectWarehouse(row) {
        console.log(row);
        this.warehouseArea.warehouseName = row.label;
        this.warehouseArea.warehouseNo = row.other;
        this.warehouseArea.warehouseId = row.id;
      },
      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "warehouseAreas", this.warehouseArea)
              .then((res) => {
                if (res.success) {
                  this.$emit("save-success");
                  if (!this.warehouseArea.pkid) {
                    this.$message.success("添加成功");
                  } else {
                    this.$message.success("编辑成功");
                  }
                  this.dialogVisible = false;
                }
                this.submitLoading = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
